import React, { useState, useEffect } from 'react';
import { Text, makeStyles } from '@fluentui/react-components';

const quotes = [
  '"Intune configures, Clarity debugs — together, they\'re the dynamic duo of device domination."',
  '"I don\'t always deploy policies, but when I do, it\'s with Intune and a side of Clarity."',
  '"Running scripts, pushing updates, living the dream — Intune and Clarity are my co-pilots."',
  '"Intune secures the fleet, Clarity clears the logs — IT zen mode: activated."',
  '"Why panic when you can automate? Intune + Clarity = nerdvana achieved."',
  '"Intune keeps my tech tight, Clarity keeps my brain light — I\'m basically the IT whisperer"',
  '"Intune sets the stage, Clarity steals the show — together, they\'re the rockstars of IT."',
  '"Deploying updates with Intune, debugging with Clarity — my IT toolkit is on point."',
  '"Intune handles the heavy lifting, Clarity keeps things crystal clear — IT mastery achieved."',
  '"Intune and Clarity: the dynamic duo that turns chaos into order."',
  '"With Intune and Clarity, every IT challenge becomes a walk in the park."',
  '"Intune deploys with precision, Clarity diagnoses with finesse — together, they\'re the IT dream team."',
  '"Intune keeps the network secure, Clarity keeps the logs clear — my IT zen is unbreakable."',
  '"Intune and Clarity: the secret sauce to my IT success."',
  '"Intune manages the devices, Clarity manages the sanity — IT bliss achieved."',
  '"Intune and Clarity: the ultimate power couple of IT efficiency."',
  '"Intune orchestrates, Clarity harmonizes — together, they\'re the symphony of IT."',
  '"Intune deploys with ease, Clarity troubleshoots with grace — my IT game is strong."',
  '"Intune and Clarity: the dynamic duo that makes IT magic happen."',
  '"Intune secures the endpoints, Clarity clears the confusion — IT nirvana achieved."',
  '"Intune and Clarity: the perfect pair for seamless IT operations."',
  '"Intune configures the devices, Clarity deciphers the logs — IT mastery unlocked."',
  '"Intune and Clarity: the ultimate tag team for IT excellence."',
  '"Intune manages the fleet, Clarity manages the chaos — IT tranquillity achieved."',
  '"Intune and Clarity: the power couple that keeps IT running smoothly."',
  '"Intune deploys the policies, Clarity diagnoses the issues — together, they\'re the heroes of IT."'
];

const useStyles = makeStyles({
  text: {
      fontSize: '1.2rem',
      textAlign: 'center',
      fontStyle: 'italic',

      '& strong': {
        fontWeight: 900,
        fontStyle: 'italic'
      }
  },
});

const RandomQuote = () => {
  const [quote, setQuote] = useState('');
  const styles = useStyles();

  useEffect(() => {
    const random = quotes[Math.floor(Math.random() * quotes.length)];
    // Highlight "Clarity"
    const highlighted = random.replace(/Clarity/g, '<strong>Clarity</strong>');
    setQuote(highlighted);
  }, []);

  return (
    <Text className={styles.text}>
      <p dangerouslySetInnerHTML={{ __html: quote }} />
    </Text>
  );
};

export default RandomQuote;